export const GET_MATERIAL_RETURN_ORDER_REQUEST = "GET_MATERIAL_RETURN_ORDER_REQUEST";
export const GET_MATERIAL_RETURN_ORDER_SUCCESS = "GET_MATERIAL_RETURN_ORDER_SUCCESS";
export const GET_MATERIAL_RETURN_ORDER_FAILURE = "GET_MATERIAL_RETURN_ORDER_FAILURE";